import { ChangeDetectionStrategy, Component } from '@angular/core';
import { FormControl } from '@angular/forms';
import { MatDialogRef } from '@angular/material/dialog';
import { Actions, ofType } from '@ngrx/effects';
import { Store } from '@ngrx/store';
import { take } from 'rxjs/operators';
import { State } from '../../../../dave-data-module/State';
import { PersonTypeActionTypes } from '../../../../dave-data-module/State/actions/personType.actions';
export interface NewRoleDialogComponentData {}
@Component({
    selector: 'app-new-role-dialog',
    template: `
        <app-detail-list-template [Data]="Data" [Inline]="true" [Editing]="true"></app-detail-list-template>
        <mat-dialog-actions>
            <div class="cancel-button-wrapper">
                <button app-button Inverted mat-dialog-close>Abbrechen</button>
            </div>
            <button app-button style="margin-left: 1rem" (click)="Save()">Speichern</button>
        </mat-dialog-actions>
    `,
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class NewRoleDialogComponent {
    constructor(
        private store: Store<State>,
        private actions: Actions,
        private dialogRef: MatDialogRef<NewRoleDialogComponent>,
    ) {}
    public Data = {
        Headline: 'Neue Rolle anlegen',
        Properties: [
            {
                key: 'Name',
                formControl: new FormControl(''),
            },
        ],
    };

    Save() {
        this.store.dispatch(
            PersonTypeActionTypes.Create({ Payload: { name: this.Data.Properties[0].formControl.value } }),
        );
        this.actions.pipe(ofType(PersonTypeActionTypes.CreateSuccess), take(1)).subscribe(person => {
            this.dialogRef.close(
                person.Payload
            );
        });
    }
}
